import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, RibbonModule, SmartbarModule, SvgIconModule, TabModule } from '@hdms/shared/ui-core';
import { AnalyticsModule, LetModule } from '@hdms/shared/util-core';

import { SearchCategoriesModule } from '../search-categories/search-categories.module';
import { HeaderSearchInputModule } from '../search-input/search-input.module';
import { SearchProductsModule } from '../search-products/search-products.module';
import { SelectableLinksModule } from '../selectable-links/selectableLinks.module';

import { SearchMobileComponent } from './search-mobile.component';

@NgModule({
  declarations: [SearchMobileComponent],
  imports: [
    ButtonModule,
    CommonModule,
    TranslationModule,
    TabModule,
    HeaderSearchInputModule,
    RibbonModule,
    SmartbarModule,
    SvgIconModule,
    SearchCategoriesModule,
    SearchProductsModule,
    SelectableLinksModule,
    LetModule,
    AnalyticsModule
  ],
  exports: [SearchMobileComponent]
})
export class HeaderSearchMobileModule {}
